import { render, staticRenderFns } from "./warm.vue?vue&type=template&id=50b053a6&scoped=true"
import script from "./warm.vue?vue&type=script&lang=js"
export * from "./warm.vue?vue&type=script&lang=js"
import style1 from "./warm.vue?vue&type=style&index=1&id=50b053a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b053a6",
  null
  
)

export default component.exports